/*
  Program Description:
  - This file contains the static meta data for every field type and label name
  in PDBNF, PBNEF and FBNER.
  - It is used in the activily logs.
*/
const fields = {
  // pdbnf fields
  pic: {
    name: 'PIC',
    is: 'v-text-field'
  },
  status: {
    name: 'Status',
    is: 'v-text-field'
  },
  representative: {
    name: 'Representative',
    is: 'v-text-field'
  },
  contactInfo: {
    name: 'Email Address',
    is: 'v-text-field'
  },
  dateOfOccurrence: {
    name: 'Date of Occurrence',
    is: 'v-text-field'
  },
  dateOfDiscovery: {
    name: 'Date of Discovery',
    is: 'v-text-field'
  },
  dateOfNotification: {
    name: 'Date of Notification',
    is: 'v-text-field'
  },
  notificationType: {
    name: 'Notification Types',
    is: 'v-textarea'
  },
  notification: {
    name: 'Notification Type',
    is: 'v-text-field'
  },
  generalCause: {
    name: 'General Cause',
    is: 'v-text-field'
  },
  specificCause: {
    name: 'Specific Cause',
    is: 'v-text-field'
  },
  specificCauseOthers: {
    name: 'Remarks (Specific Cause)',
    is: 'v-textarea'
  },
  withRequest: {
    name: 'With Request',
    is: 'v-text-field'
  },
  typeOfRequest: {
    name: 'Type of Request',
    is: 'v-autocomplete'
  },
  requestExtension: {
    name: 'Explain the reason for the request for extension of time to submit the required documents and specify what documents are included therein',
    is: 'v-textarea'
  },
  justificationExemption: {
    name: 'Justification for exemption',
    is: 'v-textarea'
  },
  justificationPostponement: {
    name: 'Justification for postponement',
    is: 'v-textarea'
  },
  justificationAlternative: {
    name: 'Justification for alternative means of notification',
    is: 'v-textarea'
  },
  justificationOthers: {
    name: 'Justification for others',
    is: 'v-textarea'
  },
  extensionDays: {
    name: 'Number of days requested for extension',
    is: 'v-text-field'
  },
  typeOfRequestOther: {
    name: 'Specify Others (Type of request)',
    is: 'v-text-field'
  },
  numberOfDataSubjectsAffected: {
    name: 'No. of Data Subjects affected',
    is: 'v-text-field'
  },
  howBreachOccurred: {
    name: '1.a How breach occurred + DPS vulnerability',
    is: 'v-textarea'
  },
  chronology: {
    name: '1.b Chronology',
    is: 'v-textarea'
  },
  numberOfDataSubjects: {
    name: '1.c Number of DS / Records',
    is: 'v-textarea'
  },
  descriptionOrNature: {
    name: '1.d Description / Nature',
    is: 'v-textarea'
  },
  likelyConsequences: {
    name: '1.e Likely Consequences',
    is: 'v-textarea'
  },
  dataProtectionOfficer: {
    name: '1.f DPO',
    is: 'v-textarea'
  },
  sensitivePersonalInformation: {
    name: '2.a SPI',
    is: 'v-textarea'
  },
  identityFraud: {
    name: '2.b Other info that may enable identity fraud',
    is: 'v-textarea'
  },
  measuresToAddress: {
    name: '3.a Measures to address the breach',
    is: 'v-textarea'
  },
  measuresToSecure: {
    name: '3.b Measures to secure/recover personal data?',
    is: 'v-textarea'
  },
  actionsToMitigateHarm: {
    name: '3.c Actions to mitigate harm? ',
    is: 'v-textarea'
  },
  actionsToInformDataSubjects: {
    name: '3.d Actions to inform data subjects? ',
    is: 'v-textarea'
  },
  measuresToPreventRecurrence: {
    name: '3.e Measures to prevent recurrence of incidence',
    is: 'v-textarea'
  },
  recordType: {
    name: 'Record Type',
    is: 'v-text-field'
  },
  dataSubjects: {
    name: 'Data Subjects',
    is: 'v-autocomplete'
  },
  specifyDataSubjectsOthers: {
    name: 'Please specify others (Data Subjects)',
    is: 'v-textarea'
  },
  specifyDataSubjectsVulnerable: {
    name: 'Please specify (Personal data of vulnerable groups)',
    is: 'v-textarea'
  },
  assignedTo: {
    name: 'Assigned Users',
    is: 'v-textarea'
  },
  extensionStart: {
    name: 'Start Date (Extension)',
    is: 'v-text-field'
  },
  extensionEnd: {
    name: 'End Date (Extension)',
    is: 'v-text-field'
  },
  startForDocumentSubmission: {
    name: 'Start Date',
    is: 'v-text-field'
  },
  endForDocumentSubmission: {
    name: 'End Date',
    is: 'v-text-field'
  },
  // pbnef fields
  dbnNumber: {
    name: 'remove DBN Number',
    is: 'v-text-field'
  },
  isSubmitted: {
    name: 'remove isSubmitted',
    is: 'v-text-field'
  },
  docketNumber: {
    name: 'Docket Number',
    is: 'v-text-field'
  },
  nameOfPic: {
    name: 'PIC',
    is: 'v-text-field'
  },
  requestFor: {
    name: 'Type of Request (PBNEF)',
    is: 'v-autocomplete'
  },
  specify: {
    name: 'remove specify',
    is: 'v-text-field'
  },
  specifyIfOthers: {
    name: 'Specify Others',
    is: 'v-text-field'
  },
  specifyIfGroup: {
    name: 'Please specify (Personal data of vulnerable groups)',
    is: 'v-textarea'
  },
  natureOfPersonalDataInvolved: {
    name: 'Nature of Personal Data Involved',
    is: 'v-autocomplete'
  },
  measuresInPlace: {
    name: 'Measures in place',
    is: 'v-textarea'
  },
  explanation: {
    name: 'Explanation',
    is: 'v-textarea'
  },
  approveReject: {
    name: 'Approve/Reject',
    is: 'v-text-field'
  },
  forAdjudication: {
    name: 'remove forAdjudication',
    is: 'v-text-field'
  },
  fileUpload: {
    name: 'File Upload',
    is: 'v-text-field'
  },
  evaluatedBy: {
    name: 'Evaluated By',
    is: 'v-text-field'
  },
  evaluation: {
    name: 'Granted/Denied',
    is: 'radio'
  },
  atLeastOneHundredIndividuals: {
    name: 'At least one hundred (100) individuals**',
    is: 'checkbox'
  },
  initialReviewedBy: {
    name: 'Initial Reviewed By',
    is: 'v-text-field'
  },
  finalReviewBy: {
    name: 'Reviewed By',
    is: 'v-text-field'
  },
  approvedBy: {
    name: 'Approved By',
    is: 'v-text-field'
  },
  justified: {
    name: 'Justified, if Delayed',
    is: 'v-text-field'
  },
  possibleViolation: {
    name: 'Possible Violation of the DPA',
    is: 'v-text-field'
  },
  'howBreachOccurred.sufficientlyProvided': {
    name: '1.a How breach occurred + DPS vulnerability',
    is: 'v-text-field'
  },
  'chronology.sufficientlyProvided': {
    name: '1.b Chronology',
    is: 'v-text-field'
  },
  'numberOfDataSubjects.sufficientlyProvided': {
    name: '1.c Number of DS / Records',
    is: 'v-text-field'
  },
  'descriptionOrNature.sufficientlyProvided': {
    name: '1.d Description / Nature',
    is: 'v-text-field'
  },
  'likelyConsequences.sufficientlyProvided': {
    name: '1.e Likely Consequences',
    is: 'v-text-field'
  },
  'dataProtectionOfficer.sufficientlyProvided': {
    name: '1.f DPO',
    is: 'v-text-field'
  },
  'sensitivePersonalInformation.sufficientlyProvided': {
    name: '2.a SPI',
    is: 'v-text-field'
  },
  'identityFraud.sufficientlyProvided': {
    name: '2.b Other info that may enable identity fraud',
    is: 'v-text-field'
  },
  'measuresToAddress.sufficientlyProvided': {
    name: '3.a Measures to address the breach',
    is: 'v-text-field'
  },
  'measuresToSecure.sufficientlyProvided': {
    name: '3.b Measures to secure/recover personal data?',
    is: 'v-text-field'
  },
  'actionsToMitigateHarm.sufficientlyProvided': {
    name: '3.c Actions to mitigate harm?',
    is: 'v-text-field'
  },
  'actionsToInformDataSubjects.sufficientlyProvided': {
    name: '3.d Actions to inform data subjects?',
    is: 'v-text-field'
  },
  'measuresToPreventRecurrence.sufficientlyProvided': {
    name: '3.e Measures to prevent recurrence of incidence',
    is: 'v-text-field'
  },
  'howBreachOccurred.remarks': {
    name: '1.a How breach occurred + DPS vulnerability (Remarks)',
    is: 'v-textarea'
  },
  'chronology.remarks': {
    name: '1.b Chronology (Remarks)',
    is: 'v-textarea'
  },
  'numberOfDataSubjects.remarks': {
    name: '1.c Number of DS / Records (Remarks)',
    is: 'v-textarea'
  },
  'descriptionOrNature.remarks': {
    name: '1.d Description / Nature (Remarks)',
    is: 'v-textarea'
  },
  'likelyConsequences.remarks': {
    name: '1.e Likely Consequences (Remarks)',
    is: 'v-textarea'
  },
  'dataProtectionOfficer.remarks': {
    name: '1.f DPO (Remarks)',
    is: 'v-textarea'
  },
  'sensitivePersonalInformation.remarks': {
    name: '2.a SPI (Remarks)',
    is: 'v-textarea'
  },
  'identityFraud.remarks': {
    name: '2.b Other info that may enable identity fraud (Remarks)',
    is: 'v-textarea'
  },
  'measuresToAddress.remarks': {
    name: '3.a Measures to address the breach (Remarks)',
    is: 'v-textarea'
  },
  'measuresToSecure.remarks': {
    name: '3.b Measures to secure/recover personal data? (Remarks)',
    is: 'v-textarea'
  },
  'actionsToMitigateHarm.remarks': {
    name: '3.c Actions to mitigate harm? (Remarks)',
    is: 'v-textarea'
  },
  'actionsToInformDataSubjects.remarks': {
    name: '3.d Actions to inform data subjects? (Remarks)',
    is: 'v-textarea'
  },
  'measuresToPreventRecurrence.remarks': {
    name: '3.e Measures to prevent recurrence of incidence (Remarks)',
    is: 'v-textarea'
  },
  'enabled.fullReport': {
    name: 'Full Report',
    is: 'checkbox'
  },
  'enabled.privacyImpactAssessment': {
    name: 'Privacy Impact Assessment',
    is: 'checkbox'
  },
  'enabled.securityIncidentManagementPolicy': {
    name: 'Security Incident Management Policy',
    is: 'checkbox'
  },
  'enabled.operationsSecurity': {
    name: 'Operations Security (Protection from malware; backup; logging and monitoring)',
    is: 'checkbox'
  },
  'enabled.systemAcquisition': {
    name: 'System Acquisition, Development & Maintenance (Security in Development and Support Processes)',
    is: 'checkbox'
  },
  'enabled.accessControl': {
    name: 'Access Control (User Responsibilities; System & Application Access Control)',
    is: 'checkbox'
  },
  'enabled.communicationsSecurity': {
    name: 'Communications Security (Network Security Management, Information Transfer)',
    is: 'checkbox'
  },
  'enabled.physicalAndEnvironmentalSecurity': {
    name: 'Physical and Environmental Security (e.g. Means of Storage, Security Measures, Form of Information Stored, Storage Type and Location)',
    is: 'checkbox'
  },
  'enabled.cryptography': {
    name: 'Cryptography',
    is: 'checkbox'
  },
  'enabled.assetManagement': {
    name: 'Asset Management (Media Handling, Acceptable Use of Assets)',
    is: 'checkbox'
  },
  'enabled.humanResourceSecurity': {
    name: 'Human Resource Security (Information Awareness, Education & Training, Disciplinary Process)',
    is: 'checkbox'
  },
  'enabled.compliance': {
    name: 'Compliance (Legal & Contractual Requirements – Cybercrime, Procedure for Reporting Malicious Attacks)',
    is: 'checkbox'
  },
  'enabled.informationSecurityPolicy': {
    name: 'Information Security Policy for the Third-Party Service Provider;',
    is: 'checkbox'
  },
  'enabled.dataSubjectNotification': {
    name: 'Copy of Data Subject Notification and its Proof of Sending',
    is: 'checkbox'
  },
  'enabled.delayInNotificationExplanation': {
    name: 'Explanation as to why there was delay in notification',
    is: 'checkbox'
  },
  'enabled.othersAttachment': {
    name: 'Others (Implementation of Security Measures / Controls)',
    is: 'checkbox'
  },
  others: {
    name: 'Others attachment (Implementation of Security Measures / Controls)',
    is: 'v-text-field'
  },
  daysForDocumentSubmission: {
    name: 'Days',
    is: 'v-text-field'
  },
  endorsedTo: {
    name: 'Endorsed to',
    is: 'v-text-field'
  },
  recipient: {
    name: 'Recipient',
    is: 'v-text-field'
  },
  statusHistory: {
    name: 'remove statusHistory',
    is: 'v-textarea'
  },
  noInformation: {
    name: 'Provide details on items tagged as "No" and "No Information yet" on the data breach notification details',
    is: 'v-textarea'
  },
  // pbnef fields
  pdbnf: {
    name: 'remove pdbnf',
    is: 'v-textarea'
  },
  timeOfOccurrence: {
    name: 'Time of Occurrence',
    is: 'v-text-field'
  },
  timeOfDiscovery: {
    name: 'Time of Discovery',
    is: 'v-text-field'
  },
  exemptionToDSNotification: {
    name: 'Exemption to DS Notification',
    is: 'radio'
  },
  justificationForExemption: {
    name: 'Justification for exemption',
    is: 'v-textarea'
  },
  dateOfDSNotification: {
    name: 'Date of DS Notification',
    is: 'v-text-field'
  },
  modeOfDSNotification: {
    name: 'Mode of DS Notification',
    is: 'v-textarea'
  },
  dateOfSubmission: {
    name: 'Date of submission of Final/Full Breach Report',
    is: 'v-text-field'
  },
  registration: {
    name: 'Registration',
    is: 'radio'
  },
  isIncidentInvolve: {
    name: 'Incident Involves Public Interests?',
    is: 'radio'
  },
  incidentInvolve: {
    name: 'Incident involves public interest',
    is: 'v-checkbox'
  },
  reasonNotNotifiedDataSubject: {
    name: 'Reason for not notifying Data Subject',
    is: 'v-textarea'
  },
  requestMade: {
    name: 'Requests made by PIC/PIP',
    is: 'v-autocomplete'
  },
  summary: {
    name: 'Summary of the security incident',
    is: 'v-textarea'
  },
  requisites: {
    name: 'Requisites',
    is: 'v-autocomplete'
  },
  timeliness: {
    name: 'Timeliness',
    is: 'v-text-field'
  },
  remarksTimeliness: {
    name: 'Remarks (Timeliness of the Report)',
    is: 'v-textarea'
  },
  remarksCause: {
    name: 'Remarks (Specific Cause)',
    is: 'v-textarea'
  },
  natureOfBreach: {
    name: 'Nature of Breach',
    is: 'v-autocomplete'
  },
  numberOfAffectedDataRecords: {
    name: 'Number of affected data subjects/records',
    is: 'v-text-field'
  },
  remarksBreach: {
    name: 'Remarks (Sensitive Personal Information)',
    is: 'v-textarea'
  },
  otherInfo: {
    name: 'Types of other information that may enable identity fraud',
    is: 'v-text-field'
  },
  remarksOtherInfo: {
    name: 'Remarks (Types of other information that may enable identity fraud)',
    is: 'v-textarea'
  },
  remarksConsequences: {
    name: 'Remarks (Likely consequences as provided by the PIC/PIP)',
    is: 'v-textarea'
  },
  organizationalSecurityMeasures: {
    name: 'Organizational Security Measures',
    is: 'textareas'
  },
  physicalSecurityMeasures: {
    name: 'Physical Security Measures',
    is: 'textareas'
  },
  technicalSecurityMeasures: {
    name: 'Technical Security Measures',
    is: 'textareas'
  },
  measuresToAddressBreach: {
    name: 'Measures taken to address the breach',
    is: 'textareas'
  },
  measuresToSecurePersonalData: {
    name: 'Measures to secure/recover personal data',
    is: 'textareas'
  },
  notifiedDataSubject: {
    name: 'Notified Data Subject',
    is: 'radio'
  },
  'fbner.actionsToMitigateHarm': {
    name: 'Actions to mitigate harm',
    is: 'textareas'
  },
  'fbner.actionsToInformDataSubjects': {
    name: 'Actions to inform data subjects',
    is: 'textareas'
  },
  'fbner.measuresToPreventRecurrence': {
    name: 'Measures to prevent recurrence of incidence',
    is: 'textareas'
  },
  'fbner.sensitivePersonalInformation': {
    name: 'Types of Sensitive Personal Information',
    is: 'v-text-field'
  },
  'fbner.likelyConsequences': {
    name: 'Likely consequences as provided by the PIC/PIP',
    is: 'v-textarea'
  },
  'fbner.notificationType': {
    name: 'Notification Type',
    is: 'radio'
  },
  'fbner.representative': {
    name: 'Annex A (Contact Details of the PIC/PIP)',
    is: 'v-textarea'
  },
  summaryOfObservationsAndFindings: {
    name: 'Summary of observations and findings',
    is: 'v-textarea'
  },
  recommendedAction: {
    name: 'Recommended Action',
    is: 'v-autocomplete'
  },
  remarksRecommendation: {
    name: 'Remarks (Recommended Action)',
    is: 'v-textarea'
  },
  possibleDpaViolation: {
    name: 'Possible Violations of the DPA',
    is: 'v-checkbox'
  },
  remarksDpaViolation: {
    name: 'Remarks (Possible Violations of the DPA)',
    is: 'v-textarea'
  },
  nameOfDpo: {
    name: 'Name of DPO',
    is: 'v-text-field'
  },
  officeAddress: {
    name: 'Office Address (DPO)',
    is: 'v-text-field'
  },
  emailAddress: {
    name: 'Email Address (DPO)',
    is: 'v-text-field'
  },
  mobileOrOfficeNumber: {
    name: 'Mobile/Office Number (DPO)',
    is: 'v-text-field'
  },
  statusOfCompliance: {
    name: 'Status of compliance',
    is: 'v-textarea'
  },
  typeOfIssuance: {
    name: 'Type of issuance',
    is: 'v-text-field'
  },
  dateOfIssuance: {
    name: 'Date of Issuance',
    is: 'v-text-field'
  },
  documentsRequired: {
    name: 'Documents Required',
    is: 'v-textarea'
  },
  recommendation: {
    name: 'Recommendation',
    is: 'v-textarea'
  },
  violations: {
    name: 'Violations',
    is: 'v-checkbox'
  },
  specifyIfSec25: {
    name: 'SEC. 25. Unauthorized Processing of Personal Information and Sensitive Personal Information',
    is: 'v-checkbox'
  },
  specifyIfSec26: {
    name: 'SEC. 26. Accessing Personal Information and Sensitive Personal Information Due to Negligence',
    is: 'v-checkbox'
  },
  specifyIfSec27: {
    name: 'SEC. 27. Improper Disposal of Personal Information and Sensitive Personal Information',
    is: 'v-checkbox'
  },
  specifyIfSec28: {
    name: 'SEC. 28. Processing of Personal Information and Sensitive Personal Information for Unauthorized Purposes',
    is: 'v-checkbox'
  },
  specifyIfSec29: {
    name: 'SEC. 29. Unauthorized Access or Intentional Breach',
    is: 'v-checkbox'
  },
  specifyIfSec30: {
    name: 'SEC. 30. Concealment of Security Breaches Involving Sensitive Personal Information',
    is: 'v-checkbox'
  },
  specifyIfSec31: {
    name: 'SEC. 31. Malicious Disclosure',
    is: 'v-checkbox'
  },
  specifyIfSec32: {
    name: 'SEC. 32. Unauthorized Disclosure',
    is: 'v-checkbox'
  },
  timelineOfActionsTaken: {
    name: 'Annex D (Timeline of Actions Taken by the PIC/PIP and CMD)',
    is: 'v-textarea'
  },
  reviewedBy: {
    name: 'reviewedBy',
    is: 'v-textarea'
  },
  endorserId: {
    name: 'remove endorserId',
    is: 'v-textarea'
  },
  assistanceProvided: {
    name: 'Assistance Provided to DS',
    is: 'v-textarea'
  }
}
export default fields
